import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { InlineNotification, Text } from '@frontend/design-system';

type PreviewNotificationProps = {
  title: ReactNode | undefined;
  description: ReactNode | undefined;
};

export const PreviewNotification = ({ title, description }: PreviewNotificationProps) => {
  return (
    <InlineNotification status='info' css={styles.previewNotification}>
      <Text size='medium'>
        <b>{title}</b> {description}
      </Text>
    </InlineNotification>
  );
};

const styles = {
  previewNotification: css`
    max-height: none;
    max-width: none;
    width: 100%;
    > div {
      width: 100%;
    }
  `,
};
